import { styled } from "styled-components";

export const MyProfileEditBtnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 32px;

  width: 600px;
  border-radius: 30px;
`;
